import { Component, Input, OnInit } from '@angular/core';
import { Partner } from 'src/app/core/data/partner/partner.model';
import { Product } from 'src/app/core/data/product/product.model';
import { environment, region_phrases, RegionNames } from 'src/environments/environment';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent implements OnInit {
  @Input()
  public product: Product;

  public translations = region_phrases[environment.region_id as keyof RegionNames];

  constructor() {}

  ngOnInit(): void {}
}
